import { NavLink } from "react-router-dom";
import "./LeagueCard.css";

function LeagueCard({ directoryLeague }) {
  const {
    id,
    name,
    county,
    state,
    divisions = [],
    sports = [],
    is_verified,
  } = directoryLeague;

  const formatLabel = (value = "") =>
    String(value)
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/_/g, " ")
      .replace(/\b\w/g, (c) => c.toUpperCase());


  const formatAgeGroup = (value) => {
    if (!value) return "";
    return value.replace("_plus", "+");
  };
  const getAgeRank = (age = "") => {
    const raw = age.toLowerCase();

    // Numeric adult brackets (35+, 40+)
    if (raw.includes("plus")) {
      return 1000 - parseInt(raw); // higher age first
    }

    if (raw === "adult") return 900;

    if (raw === "youth") return 500;

    // U-levels (U18 → U2)
    const uMatch = raw.match(/^u(\d+)$/);
    if (uMatch) {
      return parseInt(uMatch[1]); // smaller = younger
    }

    return 999;
  };
  const sortedDivisions = divisions
    .slice()
    .sort((a, b) => getAgeRank(b.age) - getAgeRank(a.age));
  const audiences = [
    ...new Set(
      sortedDivisions
        .map(d => d.audience)
        .filter(Boolean)
    ),
  ];

  const ageGroups = [
    ...new Set(
      sortedDivisions
        .map(d => d.age)
        .filter(Boolean)
    ),
  ];

  return (
    <NavLink to={`/leagues/${id}`} className="league-card-link">
      <div className="league-card">

        <div className="league-card-header">
          <div className="league-title">
            <h3 className="league-name">
              {name}
              {/* {directoryLeague.is_active && <span className="active-dot" />} */}
            </h3>
          </div>
          {is_verified && <span className="verified-badge">⭐ Verified</span>}
        </div>

        <div className="league-meta">
          {/* Sport */}
          {sports.length > 0 && (

            <div className="league-row">
              <span className="row-label">Sport:</span>
              {sports.map(formatLabel).join(", ")}
            </div>
          )}

          {audiences.length > 0 && (
            <div className="league-row">
              <span className="row-label">Audience:</span>
              <span className="row-value">
                {audiences.map(formatLabel).join(", ")}
              </span>
            </div>
          )}

          {ageGroups.length > 0 && (
            <div className="league-row">
              <span className="row-label">Age:</span>
              <span className="row-value">
                {ageGroups
                  .map(a => formatLabel(formatAgeGroup(a)))
                  .join(", ")}
              </span>
            </div>
          )}


          {/* Location (quiet) */}
          {(county || state) && (
            <div className="league-location">
              {county}{county && state ? ", " : ""}{state}
            </div>
          )}
        </div>


      </div>

    </NavLink>

  );
}

export default LeagueCard;
